/* Estilos comuns das interfaces */
import theme from 'theme';

export const uiStyles = {
    iconGroup: {
        display: 'inline-flex',
        gap: 5
    },
    actionIcon: {
        fontSize: 24,
        color: theme.palette.primary.main,
        cursor: 'pointer'
    },
    disabledActionIcon: {
        color: theme.palette.grey[400],
        cursor: 'default'
    },
    formActions: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: 10
    }
};

/* Altera a cor padrão do ícone ao passar o cursor */
export const handleIconMouseEnter = (event) => {
    event.currentTarget.style.color = theme.palette.secondary.main;
};

/* Retorna o ícone à cor padrão */
export const handleIconMouseLeave = (event) => {
    event.currentTarget.style.color = theme.palette.primary.main;
};

/* Altera a cor do ícone de exclusão */
export const handleDeleteIconMouseEnter = (event) => {
    event.currentTarget.style.color = 'red';
};

/* Retorna o ícone de exclusão à cor padrão */
export const handleDeleteIconMouseLeave = (event) => {
    event.currentTarget.style.color = 'red';
};

/* Executa o hover somente quando o ícone estiver habilitado */
export const handleEnabledIconMouseEnter = (
    event,
    disabled,
    handler = handleIconMouseEnter
) => {
    if (!disabled && typeof handler === 'function') {
        handler(event);
    }
};

/* Executa a saída do hover somente quando o ícone estiver habilitado */
export const handleEnabledIconMouseLeave = (
    event,
    disabled,
    handler = handleIconMouseLeave
) => {
    if (!disabled && typeof handler === 'function') {
        handler(event);
    }
};